import { Tabs, theme } from 'antd';
import { PageHeader } from '../../components/PageHeader';
import { KpiRow } from '../dashboard/components/KpiRow';
import { KpiCard } from '../dashboard/components/KpiCard';
import { CobradorClientesTable } from './components/CobradorClientesTable';
import { CobradorCercaTab } from './components/CobradorCercaTab';
import { useCobradorDashboard } from './api/useCobrador';
import { useT } from '../../locales';
import { formatCurrency, type SeccionCobrador } from '@aid/shared';

export function MiCobroPage() {
  const t = useT();
  const { token } = theme.useToken();
  const { data, isLoading } = useCobradorDashboard();
  const statsEmpty = isLoading && !data;

  const hoyCaption = data
    ? t('pages.cobrador.kpis.cobrosHoyCaption', {
        monto: formatCurrency(data.cobrosHoy.montoPendiente),
      })
    : undefined;
  const pendientesCaption = data
    ? t('pages.cobrador.kpis.pendientesCaption', {
        monto: formatCurrency(data.pendientesDiaAnterior.montoPendiente),
      })
    : undefined;
  const totalCaption = data
    ? t('pages.cobrador.kpis.totalGestionarCaption', {
        hoy: data.cobrosHoy.facturas,
        pendientes: data.pendientesDiaAnterior.facturas,
      })
    : undefined;

  const tabs = [
    {
      key: 'hoy',
      label: t('pages.cobrador.tabs.hoy'),
      children: <CobradorClientesTable seccion={'hoy' as SeccionCobrador} />,
    },
    {
      key: 'pendientes',
      label: t('pages.cobrador.tabs.pendientes'),
      children: <CobradorClientesTable seccion={'pendientes' as SeccionCobrador} />,
    },
    {
      key: 'visitas',
      label: t('pages.cobrador.tabs.visitas'),
      children: <CobradorClientesTable seccion={'visitas' as SeccionCobrador} />,
    },
    {
      key: 'cerca',
      label: t('pages.cobrador.tabs.cerca'),
      children: <CobradorCercaTab />,
    },
  ];

  return (
    <div>
      <PageHeader title={t('pages.cobrador.title')} subtitle={t('pages.cobrador.subtitle')} />
      <div style={{ marginBottom: 16 }}>
        <KpiRow breakpoints={{ xs: 24, sm: 12, lg: 8, xl: 4 }}>
          <KpiCard
            label={t('pages.cobrador.kpis.cobrosHoy')}
            value={String(data?.cobrosHoy.facturas ?? 0)}
            formatValue={false}
            accent="cobros"
            caption={hoyCaption}
            empty={statsEmpty}
          />
          <KpiCard
            label={t('pages.cobrador.kpis.pendientes')}
            value={String(data?.pendientesDiaAnterior.facturas ?? 0)}
            formatValue={false}
            accent="mora"
            caption={pendientesCaption}
            empty={statsEmpty}
          />
          <KpiCard
            label={t('pages.cobrador.kpis.requierenVisita')}
            value={String(data?.requierenVisita ?? 0)}
            formatValue={false}
            accent="clientes"
            empty={statsEmpty}
          />
          <KpiCard
            label={t('pages.cobrador.kpis.cobradoMes')}
            value={data?.cobradoMes ?? '0'}
            accent="pagos"
            empty={statsEmpty}
          />
          <KpiCard
            label={t('pages.cobrador.kpis.comisionMes')}
            value={data?.comisionMes ?? '0'}
            accent="none"
            empty={statsEmpty}
          />
          <KpiCard
            label={t('pages.cobrador.kpis.totalGestionar')}
            value={String(data?.totalGestionar ?? 0)}
            formatValue={false}
            accent="none"
            caption={totalCaption}
            empty={statsEmpty}
          />
        </KpiRow>
      </div>
      <div
        style={{
          background: token.colorBgContainer,
          padding: '16px 20px',
          borderRadius: 10,
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
      >
        <Tabs defaultActiveKey="hoy" items={tabs} />
      </div>
    </div>
  );
}
